export default "__VITE_ASSET__C0zuVnD6__"